import type { FrontendWidget } from '../types';
import { SchoolTypesComponent } from './SchoolTypesComponent';
import { SchoolTypesComponentB } from './SchoolTypesComponentB';
import { SchoolTypesComponentC } from './SchoolTypesComponentC';
import type { SchoolTypesConfig, SchoolTypesResolved } from './types';

export const schoolTypesWidget: FrontendWidget<
  SchoolTypesConfig,
  SchoolTypesResolved
> = {
  componentType: 'widgets.school-types',
  displayName: 'School Types',
  ComponentA: SchoolTypesComponent,
  ComponentB: SchoolTypesComponentB,
  ComponentC: SchoolTypesComponentC,
  resolveSync: (config) => config,
};
